import { Check } from 'lucide-react';

/**
 * CheckRow / CheckList — brand-blue check bullets, matching the homepage
 * card feature lists. Replaces per-page hand-rolled check SVG rows.
 */
export function CheckRow({ children, className = '' }) {
  return (
    <li className={className} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
      <span
        aria-hidden="true"
        style={{
          flexShrink: 0,
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: 'var(--brand-subtle)',
          border: '1.5px solid var(--brand-border)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: 3,
        }}
      >
        <Check size={12} color="var(--brand)" strokeWidth={3} />
      </span>
      <span style={{ fontSize: 14.5, color: 'var(--text-body)', lineHeight: 1.65 }}>{children}</span>
    </li>
  );
}

export function CheckList({ items = [], className = '', style }) {
  return (
    <ul
      className={className}
      style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10, ...style }}
    >
      {items.map((item, i) => (
        <CheckRow key={i}>{item}</CheckRow>
      ))}
    </ul>
  );
}
